module.exports = __webpack_public_path__ + "img/fitness4.954a5bc4.png";